import { Box, Grid } from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";

const services = [
  {
    title: "Laboratorio",
    description: "Análisis clínicos sin salir de casa",
    background: "#FBE8E8",
    color: "#F67A7A",
    border: "#FF8587",
    icon: "https://movicaremx.com/IMG/Sitioweb/Servicio_LAB.png",
  },
  {
    title: "Rayos X",
    description: "Radiografías con equipo portátil.",
    background: "#ECECEC",
    color: "#555555",
    border: "#555555",
    icon: "https://movicaremx.com/IMG/app_mobile/FormatPNG/Services/Rayos_X.png",
  },
  {
    title: "Traslados",
    description: "Transporte médico especializado.",
    background: "#DCECFB",
    color: "#00518C",
    icon: "https://movicaremx.com/IMG/app_mobile/FormatPNG/Services/PMR.png",
  },
];

const HomeCareServices = () => {
  const handleServices = (service) => {
    const mensaje = `Hola MoviCare, me interesaría saber más sobre su servicio de ${service} 🏥👋`;

    trackEvent(`whatsapp_servicios_${service}_MoviCare`, {
      page_path: window.location.pathname,
      page_url: window.location.href,
      section: "servicios_MoviCare",
      label: "Servicios MoviCare",
      cta_name: "enviar_whatsapp",
      message_type: "contacto_general",
      value: 1,
    });

    openWhatsApp("5514772163", mensaje, false);
  };
  return (
    <Grid container sx={design.Container}>
      <Grid size={{ xs: 1, md: 1 }} />
      <Grid size={{ xs: 10, md: 10 }} py={6}>
        <ImageLoader
          src="https://movicaremx.com/assets/movicare-logo-full-BY25PXeJ.png"
          width={267}
          height={76}
        />

        <CustomText sx={design.Title}>Servicios a domicilio</CustomText>

        <CustomText sx={design.Description}>
          Sabemos que hay padecimientos que pueden resolverse desde casa. Por
          eso contamos con MoviCare Servicios Médicos para acompañarte donde
          estés. Realizamos estudios de laboratorio, rayos X y traslados de
          pacientes con el mismo compromiso, calidad y profesionalismo que nos
          caracteriza
        </CustomText>

        <Grid container spacing={5} mt={6} justifyContent="center">
          {services.map((item, index) => (
            <Grid
              key={index}
              size={{ xs: 12, md: 3.5 }}
              onClick={() => handleServices(item.title)}
            >
              <Box
                sx={{
                  ...design.Card,
                  backgroundColor: item.background,
                }}
              >
                <Box
                  sx={{
                    ...design.IconCircle,
                    borderColor: item.color,
                  }}
                >
                  <ImageLoader src={item.icon} width={70} height={70} />
                </Box>

                <CustomText
                  sx={{
                    ...design.CardTitle,
                    color: item.color,
                  }}
                >
                  {item.title}
                </CustomText>

                <CustomText sx={design.CardDescription}>
                  {item.description}
                </CustomText>

                <Box sx={{ flexGrow: 1 }} />
                <Grid container>
                  {item.border && (
                    <Box sx={design.Resul(item)}>
                      <ImageLoader
                        src="https://centromedicomedam.com/IMG/centromedicoMEDAM/PDF.svg"
                        width={30}
                      />
                      <CustomText
                        fontFamily="Nunito"
                        fontSize={16}
                        fontWeight="bold"
                        textAlign="left"
                        color="#888888"
                      >
                        Resultados Digitales
                      </CustomText>
                    </Box>
                  )}
                </Grid>

                <CustomText
                  sx={{
                    ...design.More,
                    color: item.color,
                  }}
                >
                  Ver más
                  <KeyboardArrowRight fontSize="small" />
                </CustomText>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid size={{ xs: 1, md: 1 }} />
    </Grid>
  );
};

export default HomeCareServices;

const design = {
  Container: {
    backgroundColor: "#F6FBF2",
  },
  Title: {
    fontFamily: "Nunito",
    color: "#00528C",
    fontWeight: "bold",
    fontSize: {
      xs: 30,
      md: 50,
    },
    mt: 2,
    textAlign: "left",
  },
  Description: {
    mt: 2,
    textAlign: "justify",
    color: "#3A3A3A",
    fontFamily: "Nunito",
    fontSize: {
      xs: 18,
      md: 20,
    },
    lineHeight: 1.5,
  },
  Card: {
    height: "340px",
    borderRadius: "24px",
    padding: "30px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 8px 18px rgba(0,0,0,.15)",
    transition: ".35s",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 15px 30px rgba(0,0,0,.20)",
    },
  },
  IconCircle: {
    width: 90,
    height: 90,
    borderRadius: "50%",
    border: "1.5px solid",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mb: 4,
    background: "#fff",
  },
  CardTitle: {
    fontFamily: "Nunito",
    fontSize: 24,
    fontWeight: "bold",
    textAlign: "left",
  },
  CardDescription: {
    fontFamily: "Nunito",
    color: "#666",
    fontSize: 16,
    mt: 1,
    lineHeight: 1.4,
    textAlign: "left",
  },
  More: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    gap: 0.5,
    fontFamily: "Nunito",
    fontWeight: "bold",
    cursor: "pointer",
    mt: 2,
  },
  Resul: (item) => ({
    border: `2px solid ${item.border}`,
    backgroundColor: "#FFF",
    marginTop: 2,
    px: 2,
    py: 1,
    borderRadius: "20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  }),
};
